import { useState } from "react";
import { FaTrash } from "react-icons/fa";
import { FormField, SoftButton } from "../../../UI/DesignStandards";
import {
  NestedItemCard,
  NestedItemContent,
  NestedItemActions,
} from "../../../DesignSystem";

const PrizeFundItem = ({
  item,
  editMode,
  validationErrors,
  onDescriptionChange,
  onAmountChange,
  onDelete,
  canManage,
  user,
  isDeleting,
  isPayoutFinalized,
}) => {
  const [confirmingDelete, setConfirmingDelete] = useState(false);

  const handleDelete = () => {
    onDelete(item.id);
    setConfirmingDelete(false);
  };

  return (
    <NestedItemCard>
      <NestedItemContent>
        <div className="flex flex-col sm:flex-row sm:items-center gap-3">
          <div className="flex-1 min-w-0">
            <span className="font-medium text-brand-charcoal">
              {editMode ? (
                <FormField
                  type="text"
                  value={item.description || ""}
                  onChange={(e) => onDescriptionChange(item.id, e.target.value)}
                  placeholder="Prize Fund Name"
                  className="w-full"
                  disabled={isPayoutFinalized}
                />
              ) : (
                item.description || "Additional Prize Fund"
              )}
            </span>
          </div>
          <div className="flex flex-col sm:flex-row sm:items-center gap-3">
            <div className="text-right">
              <div className="text-sm font-medium text-brand-charcoal mb-1">
                Board total
              </div>
              {editMode ? (
                <FormField
                  type="number"
                  min="0"
                  step="0.01"
                  value={item.amount || ""}
                  onChange={(e) => onAmountChange(item.id, e.target.value)}
                  className={`w-32 ${
                    validationErrors[item.id] ? "border-red-500" : ""
                  }`}
                  disabled={isPayoutFinalized}
                />
              ) : (
                <div className="text-lg font-score font-semibold text-brand-charcoal">
                  ${parseFloat(item.amount || 0).toFixed(2)}
                </div>
              )}
            </div>
          </div>
        </div>
      </NestedItemContent>

      {editMode && user && canManage && (
        <NestedItemActions>
          {confirmingDelete ? (
            <div className="flex items-center gap-2">
              <span className="text-sm text-red-600 font-medium">Delete?</span>
              <SoftButton
                color="red"
                size="xs"
                onClick={handleDelete}
                disabled={isDeleting || isPayoutFinalized}
                title={
                  isPayoutFinalized
                    ? "Payouts have been locked and cannot be changed"
                    : ""
                }
              >
                {isDeleting ? (
                  <>
                    <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-red-600 mr-1"></div>
                    Deleting...
                  </>
                ) : (
                  "Yes"
                )}
              </SoftButton>
              <SoftButton
                color="gray"
                size="xs"
                onClick={() => setConfirmingDelete(false)}
                disabled={isDeleting || isPayoutFinalized}
                title={
                  isPayoutFinalized
                    ? "Payouts have been locked and cannot be changed"
                    : ""
                }
              >
                No
              </SoftButton>
            </div>
          ) : (
            <SoftButton
              color="red"
              size="sm"
              onClick={() => setConfirmingDelete(true)}
              disabled={isDeleting || isPayoutFinalized}
              title={
                isPayoutFinalized
                  ? "Payouts have been locked and cannot be changed"
                  : "Delete this prize fund"
              }
            >
              <FaTrash className="mr-1.5 h-3.5 w-3.5" />
              {isDeleting ? "Deleting..." : "Delete"}
            </SoftButton>
          )}
        </NestedItemActions>
      )}
    </NestedItemCard>
  );
};

export default PrizeFundItem;
